var t=function(t){document.body.removeAttribute(t?"data-corva-theme-light":"data-corva-theme-dark"),document.body.setAttribute(t?"data-corva-theme-dark":"data-corva-theme-light","")};export{t as setThemeVariables};
